import React, { Component } from 'react';
import { Form, Input } from 'antd';
import SearchIcon from '../icon/search';
import './index.scss'
import intl from 'react-intl-universal';

class Search extends Component {
    constructor (props) {
        super(props);
        this.state = {
            value: this.props.value
        }
    }

    setValue = (value) => {
        this.setState({ value })
    }

    onFinish = () => {
        const { value } = this.state;
        this.props.onSearch(value);
    }

    onChange = (e) => {
        const { value } = e.target;
        this.setValue(value);
        if (!value) {
            this.props.onClear();
        }
    }

    render () {
        const { value } = this.state;
        const placeholder = intl.formatMessage({id: 'SearchTemplate'});
        return (
            <Form autoComplete="off" onFinish={this.onFinish} className={this.props.className} role="search">
                <Input
                    type="search"
                    className='search'
                    maxLength="320"
                    value={value}
                    placeholder={placeholder}
                    aria-label={placeholder}
                    allowClear={true}
                    bordered={false}
                    prefix={(
                        <SearchIcon style={{marginRight:5,fontSize:18}}></SearchIcon>
                    )}
                    onChange={this.onChange} />
            </Form>
        )
    }
}
export default Search;
